import { render, staticRenderFns } from "./UserInterfacePreferences.vue?vue&type=template&id=1828319f"
import script from "./UserInterfacePreferences.vue?vue&type=script&lang=js"
export * from "./UserInterfacePreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports